import * as Yup from "yup";

const salesReturnSchema = {};

salesReturnSchema.validateAdd = (values) => {
  let schema = Yup.object({
    challan_id: Yup.string().required("Challan No is Required."),
    cust_id: Yup.string().required("Customer Name is Required."),
    challan_date: Yup.string().required("Challan Date is Required."),
    // inv_no: Yup.string().required("Invoice No is Required.").matches(/^[aA-z0-9Z-\s\/\:]+$/, `Invoice should be alphanumeric`),
    reason: Yup.string()
      .required("Reason is Required"),
      // .matches(/^[a-zA-Z0-9\s]+$/, "Reason must be alphanumeric characters."),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),
          qty: Yup.number()
            .typeError("Item Reqd. Qty must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .min(0, "Item Reqd. Qty must be greater than or equal to 0")
            .nullable()
            .required("Item  Qty field is required")
            .max(99999999.99, "Item Qty cannot exceed 8 Digits"),
          rate: Yup.number()
            .typeError("Item Rate must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .min(0, "Item Rate must be greater than or equal to 0")
            .nullable()
            .required("Item Rate field is required")
            .max(99999999999.9999, "Item Rate cannot exceed 11 Digits"),
          amount: Yup.string().required("Item Amount is Required"),

          disc: Yup.string().required("Item Discount is Required"),
          godown_id: Yup.string().required("Item Godown Name is Required"),
        })
      )
      .min(1, "Invalid Product Details."),
  });

  return schema.validate(values, { abortEarly: false }).catch((err) => err);
};

salesReturnSchema.validateEdit = (values) => {
  let schema = Yup.object({
    cust_id: Yup.string().required("Customer Name is Required."),
    challan_date: Yup.string().required("Challan Date is Required."),
    // inv_no: Yup.string().required("Invoice No is Required.").matches(/^[aA-z0-9Z-\s\/\:]+$/, `Invoice should be alphanumeric`),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),
          requested_qty: Yup.number()
            .typeError("Item Reqd. Qty must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .min(0, "Item Reqd. Qty must be greater than or equal to 0")
            .nullable()
            .required("Item Reqd. Qty field is required")
            .max(99999999.99, "Item Reqd. Qty cannot exceed 8 Digits"),
          rate: Yup.number()
            .typeError("Item Rate must be number")
            .transform((_, v) => (v == "" ? null : Number(v)))
            .min(0, "Item Rate must be greater than or equal to 0")
            .nullable()
            .required("Item Rate field is required")
            .max(99999999999.9999, "Item Rate cannot exceed 11 Digits"),
          amount: Yup.string().required("Item Amount is Required"),
          disc: Yup.string().required("Item Discount is Required"),
          godown_id: Yup.string().required("Item Godown Name is Required"),
        })
      )
      .min(1, "Invalid Product Details."),
  });

  return schema.validate(values, { abortEarly: false }).catch((err) => err);
};

export default salesReturnSchema;
